export const contractsZh = {
  title: '合同管理',
  create: '新建合同',
  loading: '加载中...',
  emptyTitle: '暂无合同',
  emptyDesc: '您还没有创建合同',
  emptyAction: '创建第一个合同',
  columns: {
    number: '合同编号',
    title: '合同名称',
    party: '对方单位',
    amount: '合同金额',
    status: '状态',
    actions: '操作',
  },
  actions: {
    view: '查看',
  },
  status: {
    DRAFT: '草稿',
    PENDING: '审批中',
    APPROVED: '已批准',
    REJECTED: '已拒绝',
    SEALED: '已盖章',
    EXECUTED: '执行中',
    EXPIRED: '已过期',
  },
};

export type ContractsTranslations = typeof contractsZh;
